import React, { MutableRefObject, useEffect, useRef, useState } from 'react';
import { SvgIconTypeMap } from '@material-ui/core';
import { OverridableComponent } from '@material-ui/core/OverridableComponent';
import withStyles from '@material-ui/core/styles/withStyles';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import { ExtendMui } from '@material-ui/pickers/typings/extendMui';
import CheckIcon from '@material-ui/icons/Check';

// const----------------------------------------------------
export const EmptyInputMsg = '請填寫這個欄位。';
export const dvariant = 'standard';

// interface----------------------------------------------------
interface ICustomProps {
  inputRef?: MutableRefObject<HTMLInputElement | undefined>;
  verifyBeforeChange?: boolean;
  verifiers?: IVerifier[];
}

interface IVerifier {
  func: (value: string) => boolean;
  text: string;
}
export interface IInput
  extends Omit<ExtendMui<TextFieldProps>, 'inputRef'>,
    ICustomProps {
  minLength?: number;
  maxLength?: number;
}

// style----------------------------------------------------
const StyleTextField = withStyles({
  root: {
    width: '100%',
    '& input, .MuiInputBase-multiline': {
      padding: '0.675em 0.75em',
      fontSize: '1.15em',
    },
  },
})(TextField);
// Input----------------------------------------------------
export const GreenCheck = (
  props: OverridableComponent<SvgIconTypeMap> | Record<string, unknown>
): JSX.Element => <CheckIcon style={{ color: 'green' }} {...props} />;

const Input = (props: IInput): JSX.Element => {
  const {
    value,
    variant = dvariant,
    inputRef = useRef(),
    verifyBeforeChange = false,
    inputProps,
    minLength = inputProps?.minLength,
    maxLength = inputProps?.maxLength,
    error,
    helperText,
    ...other
  } = props;
  let { verifiers = [] } = props;
  const [message, setMessage] = useState('');
  const [FirstVerify, setFirstVerify] = useState(verifyBeforeChange);

  if (minLength && value) {
    verifiers = [
      {
        func: (v: string) => v.length < minLength,
        text: `請將這段文字加長到 ${minLength} 個字元以上 (目前使用字元數：${
          (value as string).length
        })。`,
      },
      ...verifiers,
    ];
  }

  useEffect(() => {
    // 始設畫面預設不 verify , 除非 verifyBeforeChange = true
    if (!FirstVerify) {
      setFirstVerify(true);
      setMessage('');
      return;
    }

    // 驗使用者設定之 verifier, 不驗空值(給 HTML required 驗)
    if (value && verifiers.length > 0) {
      const veriObj = verifiers.find((obj) => obj.func(value as string));
      if (veriObj) {
        setMessage(veriObj.text);
        return;
      }
    }

    // 驗 HTML validation
    if (inputRef.current && inputRef.current.validationMessage.length > 0) {
      setMessage(inputRef.current.validationMessage);
      return;
    }

    // 先前檢驗都 pass
    setMessage('');
  }, [value, verifyBeforeChange]);

  return (
    <StyleTextField
      {...other}
      value={value}
      variant={variant}
      inputRef={inputRef}
      inputProps={{
        ...inputProps,
        minLength,
        maxLength,
      }}
      error={error || message.length > 0}
      helperText={message || helperText}
    />
  );
};

export default Input;
